import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { handleLocationSelect } from '../../redux/actions/siteSettingsActions';
import ViewHeader from '../viewHeader/viewHeader';
import { locationEnums } from '../../appSettings';
import './locationPicker.scss';

const locationOptions = [
  {
    id: locationEnums.NORTH_AMERICA,
    heightOffset: 0.3,
    widthOffset: 0.02,
  },
  {
    id: locationEnums.EUROPE,
    heightOffset: 0.14,
    widthOffset: 0.38,
  },
  {
    id: locationEnums.CANARY_ISLANDS,
    heightOffset: 0.34,
    widthOffset: 0.26,
  },
  {
    id: locationEnums.ASIA,
    heightOffset: 0.36,
    widthOffset: 0.72,
  },
  {
    id: locationEnums.CARIBEAN_CENTRAL_AMERICA,
    heightOffset: 0.5,
    widthOffset: 0.06,
  },
  {
    id: locationEnums.SOUTH_AMERICA,
    heightOffset: 0.70,
    widthOffset: 0.08,
  },
  {
    id: locationEnums.AFRICA,
    heightOffset: 0.56,
    widthOffset: 0.44,
  },
  {
    id: locationEnums.ANYWHERE,
    heightOffset: 0.78,
    widthOffset: 0.5,
  },
];


const LocationPicker = ({ onHandleLocationSelect, selectedLocations, labels, baseUrl, cdnBaseUrl }) => {
  const [innerWidth, setInnerWidth] = useState(window?.innerWidth);
  const [innerHeight, setInnerHeight] = useState(window?.innerHeight);
  const handleResize = () => {
    setInnerWidth(window?.innerWidth);
    setInnerHeight(window?.innerHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });
  
  const getWidthAndHeightVars = (id, heightOffset, widthOffset) => {
    const heightAdjustment = innerHeight/innerWidth < 1 ? innerWidth*0.05 : 0;  
    const widthAdjustment = innerHeight/innerWidth < 1 ? innerWidth*0.1 : 0;  
    return {
      [`--${id}-height-value`]: `${((innerWidth*heightOffset)+heightAdjustment)}px`,
      [`--${id}-width-value`]: `${((innerWidth*widthOffset)+widthAdjustment)}px`,
    }
  }


  const getBackgroundVars = () => {
    return {
      "--background-position-value": `-${innerWidth*0.45}px`,
      backgroundImage: `url("${cdnBaseUrl || baseUrl}/static/images/world-map.svg")`,
    }
  }

  return (
    <div className="vf-view vf-location-picker-container">
      <ViewHeader header={labels.traitLocationHeader} />
      <div className="vf-location-picker__world-map-wrapper">
        <div className="vf-location-picker__image" style={getBackgroundVars()}/>
        {locationOptions.map(({id, heightOffset, widthOffset, i}) => {
          const active = selectedLocations?.includes(id) || selectedLocations?.includes(locationEnums.ANYWHERE);
          return (
            <div
              key={id}
              tabIndex={i}
              role='button'
              onClick={() => { onHandleLocationSelect(id) }}
              onKeyDown={(e) => {
                if (e.keycode === 13) {
                  onHandleLocationSelect(id);
                }
              }}
              style={getWidthAndHeightVars(id, heightOffset, widthOffset)}
              className={`vf-location-option vf-location-option-${id} ${active ? 'vf-location-option--active' : ''}`}
            >
              <button
                type='button'
                className='vf-location-option__button'
                data-test={`${id.toLowerCase()}-button${active ? '-selected' : ''}`}>
                  {labels[`locationPicker_${id}`]}
                </button>
            </div>
          );
        })}
      </div>
    </div>
  )
}

LocationPicker.propTypes = {
  onHandleLocationSelect: PropTypes.func.isRequired,
  selectedLocations: PropTypes.string,
  labels: PropTypes.shape({
    traitLocationHeader: PropTypes.string.isRequired,
    locationPicker_ASIA: PropTypes.string.isRequired,
    locationPicker_AFRICA: PropTypes.string.isRequired,
    locationPicker_CANARY_ISLANDS: PropTypes.string.isRequired,
    locationPicker_CARIBEAN_CENTRAL_AMERICA: PropTypes.string.isRequired,
    locationPicker_EUROPE: PropTypes.string.isRequired,
    locationPicker_NORTH_AMERICA: PropTypes.string.isRequired,
    locationPicker_SOUTH_AMERICA: PropTypes.string.isRequired,
    locationPicker_ANYWHERE: PropTypes.string.isRequired,
  }).isRequired,
  baseUrl: PropTypes.string.isRequired,
  cdnBaseUrl: PropTypes.string,
};

LocationPicker.defaultProps = {
  selectedLocations: null,
  cdnBaseUrl: '',
};

const mapStateToProps = ({ siteSettings, attributeCollection }) => {
  const labels = {
    traitLocationHeader: attributeCollection.traitLocationHeader, 
    locationPicker_ASIA: attributeCollection.locationPicker_ASIA,
    locationPicker_AFRICA: attributeCollection.locationPicker_AFRICA,
    locationPicker_CANARY_ISLANDS: attributeCollection.locationPicker_CANARY_ISLANDS,
    locationPicker_CARIBEAN_CENTRAL_AMERICA: attributeCollection.locationPicker_CARIBEAN_CENTRAL_AMERICA,
    locationPicker_EUROPE: attributeCollection.locationPicker_EUROPE,
    locationPicker_NORTH_AMERICA: attributeCollection.locationPicker_NORTH_AMERICA,
    locationPicker_SOUTH_AMERICA: attributeCollection.locationPicker_SOUTH_AMERICA,
    locationPicker_ANYWHERE: attributeCollection.locationPicker_ANYWHERE,
  }
  return {
    selectedLocations: siteSettings.filters.selectedLocations,
    labels,
    baseUrl: siteSettings.baseUrl,
    cdnBaseUrl: siteSettings.cdnBaseUrl,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onHandleLocationSelect: (locationOption) => {
      dispatch(handleLocationSelect(locationOption));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationPicker);